import { useAppScopeStore } from '@frontend/scope';
import { MessagesTypes } from '..';

const keys = {
  bulk: 'bulk-messages',
  tenDLC: 'ten-dlc',
};

export const useBulkQueryKeys = () => {
  const { selectedLocationIds } = useAppScopeStore();
  const singleLocationId = selectedLocationIds[0];

  return {
    // Do not change the `batches` key since it is also being used in the `api-bulk-messaging's useListCampaignDrafts` query too.
    batches: () => [singleLocationId, keys.bulk, 'batches'],
    batch: (batchId: string) => [singleLocationId, keys.bulk, 'batch', batchId],
    filterOptions: () => [singleLocationId, keys.bulk, 'filters'],
    recipients: (filters: MessagesTypes.Filters, searchToken?: string) => [
      singleLocationId,
      keys.bulk,
      'recipients',
      filters,
      searchToken,
    ],
    countRecipients: (filters: MessagesTypes.Filters) => [singleLocationId, keys.bulk, 'count-recipients', filters],
    contactLists: () => [singleLocationId, keys.bulk, 'contact-lists'],
    contactList: (listId: string) => [singleLocationId, keys.bulk, 'contact-list', listId],
    registrationStatus: () => [singleLocationId, keys.tenDLC, 'registration-status'],
    registrationStatusDetails: () => [singleLocationId, keys.tenDLC, 'registration-status-details'],
    locationTCRBrand: () => [singleLocationId, keys.tenDLC, 'location-tcr-brand'],
    defaultPhoneRecord: () => [singleLocationId, keys.bulk, 'default-phone-record'],
  };
};
